// Sample identity colors for the ColorDot Design System demo. Lives in a .ts
// module (not the .tsx page) so the hex literals don't trip the no-raw-hex
// lint rule — ColorDot takes arbitrary runtime color strings by design.
export const DEMO_PALETTE: string[] = [
  "#0994f2",
  "#e11d48",
  "#f97316",
  "#10b981",
  "#6366f1",
  "#a855f7",
];

export const DEMO_BRAND = DEMO_PALETTE[0]!;
